<script>
import feather from 'feather-icons';
import ProjectSingle from './ProjectSingle.vue';
import projects from '../../data/projects';

export default {
	components: { ProjectSingle },
	data: () => ({
		projects,
		searchProject: '',
	}),
	computed: {
		filteredProjects() {
			if (this.searchProject) {
				const re = new RegExp(this.searchProject, 'i');
				return this.projects.filter((el) => el.title.match(re)).slice(0, 6);
			}
			return this.projects.slice(0, 6);
		},
	},
	mounted() { feather.replace(); },
};
</script>

<template>
	<section class="pt-12 sm:pt-16">
		<!-- Heading -->
		<div class="mb-8 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4" data-aos="fade-up" data-aos-delay="100">
			<div>
			<p class="eyebrow mb-2">
				Featured Work
			</p>
			<h2 class="font-general-bold text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white">
				Recent <span class="text-gradient">Projects</span>
			</h2>
			</div>
			<p class="max-w-md font-general-regular text-sm text-gray-500 dark:text-slate-400">
				A snapshot of SaaS, AI automation, and production systems shipped for founders and teams.
			</p>
		</div>

		<!-- Search bar -->
		<div class="mb-8" data-aos="fade-up" data-aos-delay="200">
			<div class="relative max-w-md surface-card">
				<div class="absolute inset-y-0 left-3.5 flex items-center pointer-events-none text-gray-400 dark:text-slate-500">
					<i data-feather="search" class="w-4 h-4" />
				</div>
				<input
					v-model="searchProject"
					type="search"
					placeholder="Search projects…"
					class="w-full pl-10 pr-4 py-3 rounded-lg text-sm font-general-medium
						bg-transparent
						border border-transparent
						text-gray-800 dark:text-slate-200
						placeholder-gray-400 dark:placeholder-slate-600
						focus:outline-none focus:border-amber-400 dark:focus:border-amber-500/60
						focus:ring-2 focus:ring-amber-500/10
						transition-all duration-200"
				/>
			</div>
		</div>

		<!-- Grid -->
		<div
			class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 items-start"
			data-aos="fade-up" data-aos-delay="300"
		>
			<ProjectSingle
				v-for="(project, index) in filteredProjects"
				:key="project.id"
				:project="project"
				:data-aos="'fade-up'"
				:data-aos-delay="300 + index * 80"
			/>
		</div>
	</section>
</template>
